<!-- <template>
	<div class="module_container full" style="position: relative;" v-loading="loading">
		<vxe-grid v-bind="gridOptions" :key="gridKey" v-if="gridOptions" @toolbar-button-click="toolbarButtonClickEvent"
			:ref="moduleName+'_list'">

		</vxe-grid>

		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />






		<vxe-table :data="exportData" style="display: none;" ref="exportTable">
			<vxe-column field="code" title="商品编码" cell-type="string"></vxe-column>
			<vxe-column field="name" title="商品名称" cell-type="string"></vxe-column>
			<vxe-column field="model" title="规格型号" cell-type="string"></vxe-column>
			<vxe-column field="weight" title="重量" cell-type="string"></vxe-column>
			<vxe-column field="recommendlevel" title="推荐等级" cell-type="string"></vxe-column>
			<vxe-column field="suppliername_a" title="供应商A" cell-type="string"></vxe-column>
			<vxe-column field="supplierprice_a" title="单价A" cell-type="string"></vxe-column>
			<vxe-column field="suppliername_b" title="供应商B" cell-type="string"></vxe-column>
			<vxe-column field="supplierprice_b" title="单价B" cell-type="string"></vxe-column>
			<vxe-column field="suppliername_c" title="供应商C" cell-type="string"></vxe-column>
			<vxe-column field="supplierprice_c" title="单价C" cell-type="string"></vxe-column>
			<vxe-column field="suppliername_d" title="供应商D" cell-type="string"></vxe-column>
			<vxe-column field="supplierprice_d" title="单价D" cell-type="string"></vxe-column>
		</vxe-table>




	</div>
</template>
<style>

</style>
<style scoped>

</style> -->
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'parcelIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'parcel',
				windowName: '快递',
				exportData: [],
				currentrow: null,
				distributionShow: false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			distribution(row) {
				this.currentrow = row
				this.distributionShow = true
			},
			distributionSubmit() {
				let data = this.$refs.distribution.submit()
				if (data) {
					this.$api[this.moduleName].distribution(data.id, data).then(() => {
						this.distributionShow = false
						this.customreload()
					})
				}
			}
		},
		components: {
			
		}
	}
</script>
